export const localstorageNamesToDelete = (localstorageNames: string[]) => {
  localstorageNames.forEach((storageName: string) => {
    if (localStorage.getItem(storageName)) {
      localStorage.removeItem(storageName);
    }
  });
};
